import { MIGRATION_COST_SCHEDULE_TRACKER } from '../features/actions/fetchMigrationCostScheduleTrackerData';

export default (state = [], action) => {
  switch (action.type) {
    case MIGRATION_COST_SCHEDULE_TRACKER:
      return action.payload;
    default:
      return state;
  }
};
